import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import DataTableLayout from "layouts/DatatableLayout";
import { Stack } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { getReportSalesku } from "../../redux/handlers/report/getReportSalesku.handler";
import { getReportSaleSkuListsnew } from "../../redux/handlers/report/getReportSaleSkuListsnew.handler";
import { getReportSaleSkuListsold } from "../../redux/handlers/report/getReportSaleSkuListsold.handler";
import { ModalAllder } from "layouts/ModalAllder";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th"; // ใส่ locale ไทย
import { getFullUrlPath } from "utils/HandleFileFunction";
export function ReportReservationBySku() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionShop = _useState1[0], setOptionShop = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), shopId = _useState2[0], setShopId = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionBranch = _useState3[0], setOptionBranch = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), branchId = _useState4[0], setBranchId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(null), 2), month = _useState5[0], setMonth = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), optionSale = _useState6[0], setOptionSale = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), saleId = _useState7[0], setSaleId = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), modelText = _useState8[0], setmodelText = _useState8[1];
    var _useState9 = _sliced_to_array(useState(null), 2), startMonth = _useState9[0], setStartMonth = _useState9[1];
    var _useState10 = _sliced_to_array(useState(null), 2), endMonth = _useState10[0], setEndMonth = _useState10[1];
    var _useState11 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 1000,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalProduct = _useState11[0], setModalProduct = _useState11[1];
    var getReportSaleskuReducer = useAppSelector(function(state) {
        return state.getReportSaleskuReducer;
    });
    // // Load data
    useEffect(function() {
        dispatch(getReportSalesku({
            // month: month ? moment(month).format("YYYY-MM") : "",
            month: startMonth ? moment(startMonth).format("YYYY-MM") : "",
            emonth: endMonth ? moment(endMonth).format("YYYY-MM") : "",
            shbranchid: parseInt(branchId),
            shopid: parseInt(shopId),
            saleid: parseInt(saleId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        shopId,
        branchId,
        startMonth,
        endMonth,
        saleId
    ]);
    useEffect(function() {
        setIsLoading(getReportSaleskuReducer.isFetching);
        if (getReportSaleskuReducer.data) {
            var data = getReportSaleskuReducer.data.data;
            setDatalist(data);
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var sharr = [];
            var bhaarr = [];
            var salarr = [];
            var shopSet = new Set();
            var branchSet = new Set();
            var saleSet = new Set();
            data.forEach(function(ele) {
                if (!shopSet.has(ele.jb_saleshsku_shid)) {
                    var _ele_ShShop, _ele_ShBranch;
                    shopSet.add(ele.jb_saleshsku_shid);
                    sharr.push({
                        value: ele.jb_saleshsku_shid,
                        label: "".concat(ele === null || ele === void 0 ? void 0 : (_ele_ShShop = ele.ShShop) === null || _ele_ShShop === void 0 ? void 0 : _ele_ShShop.sh_shop_name, " (").concat(ele === null || ele === void 0 ? void 0 : (_ele_ShBranch = ele.ShBranch) === null || _ele_ShBranch === void 0 ? void 0 : _ele_ShBranch.sh_branch_name, ")")
                    });
                }
                if (!branchSet.has(ele.jb_saleshsku_shbranchid)) {
                    var _ele_ShBranch1, _ele_ShShop1;
                    branchSet.add(ele.jb_saleshsku_shbranchid);
                    bhaarr.push({
                        value: ele.jb_saleshsku_shbranchid,
                        label: "".concat(ele === null || ele === void 0 ? void 0 : (_ele_ShBranch1 = ele.ShBranch) === null || _ele_ShBranch1 === void 0 ? void 0 : _ele_ShBranch1.sh_branch_name, " (").concat(ele === null || ele === void 0 ? void 0 : (_ele_ShShop1 = ele.ShShop) === null || _ele_ShShop1 === void 0 ? void 0 : _ele_ShShop1.sh_shop_name, ")")
                    });
                }
                if (!saleSet.has(ele.jb_saleshsku_saleid)) {
                    var _ele_SaleUser;
                    saleSet.add(ele.jb_saleshsku_saleid);
                    salarr.push({
                        value: ele.jb_saleshsku_saleid,
                        label: "".concat(ele === null || ele === void 0 ? void 0 : (_ele_SaleUser = ele.SaleUser) === null || _ele_SaleUser === void 0 ? void 0 : _ele_SaleUser.sys_user_fullname)
                    });
                }
            });
            setOptionShop(_to_consumable_array(all).concat(_to_consumable_array(sharr)));
            setOptionBranch(_to_consumable_array(all).concat(_to_consumable_array(bhaarr)));
            setOptionSale(_to_consumable_array(all).concat(_to_consumable_array(salarr)));
        }
    }, [
        getReportSaleskuReducer
    ]);
    var columns = [
        {
            name: "เดือน",
            selector: function(row) {
                return moment(row === null || row === void 0 ? void 0 : row.jb_saleshsku_month).locale("th").format("MMMM YYYY");
            }
        },
        {
            name: "ชื่อเซลล์",
            selector: function(row) {
                var _row_SaleUser;
                return (row === null || row === void 0 ? void 0 : (_row_SaleUser = row.SaleUser) === null || _row_SaleUser === void 0 ? void 0 : _row_SaleUser.sys_user_fullname) || "-";
            }
        },
        {
            name: "ร้านค้า",
            selector: function(row) {
                var _row_ShShop;
                return row === null || row === void 0 ? void 0 : (_row_ShShop = row.ShShop) === null || _row_ShShop === void 0 ? void 0 : _row_ShShop.sh_shop_name;
            },
            // width: "250px",
            cell: function(row, index, column, id) {
                var _row_ShShop, _row_ShBranch;
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row === null || row === void 0 ? void 0 : (_row_ShShop = row.ShShop) === null || _row_ShShop === void 0 ? void 0 : _row_ShShop.sh_shop_name,
                        " ( ",
                        row === null || row === void 0 ? void 0 : (_row_ShBranch = row.ShBranch) === null || _row_ShBranch === void 0 ? void 0 : _row_ShBranch.sh_branch_name,
                        " )"
                    ]
                });
            }
        },
        {
            name: "SKU เดิม",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshsku_totalold;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Link, {
                    onClick: function() {
                        setmodelText("รายการสินค้าเก่า");
                        setModalProduct(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true,
                                typeData: "old",
                                data: {
                                    id: row === null || row === void 0 ? void 0 : row.jb_saleshsku_id
                                }
                            });
                        });
                    },
                    style: {
                        marginRight: 5,
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: row === null || row === void 0 ? void 0 : row.jb_saleshsku_totalold
                });
            }
        },
        {
            name: "SKU ใหม่",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshsku_totalnew;
            },
            // width: "150px",
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Link, {
                    onClick: function() {
                        setmodelText("รายการสินค้าใหม่");
                        setModalProduct(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true,
                                typeData: "new",
                                data: {
                                    id: row === null || row === void 0 ? void 0 : row.jb_saleshsku_id
                                }
                            });
                        });
                    },
                    style: {
                        marginRight: 5,
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: row === null || row === void 0 ? void 0 : row.jb_saleshsku_totalnew
                });
            }
        },
        {
            name: "จำนวนบิลการจอง",
            selector: function(row) {
                return row === null || row === void 0 ? void 0 : row.jb_saleshsku_reservenew;
            },
            center: "true"
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานใบจอง SKU ของเซล"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานใบจอง SKU ของเซล"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4 pb-0",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "เดือนเริ่มต้น"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: startMonth,
                                                onChange: function(date) {
                                                    return setStartMonth(date);
                                                },
                                                dateFormat: "yyyy-MM",
                                                showMonthYearPicker: true,
                                                className: "form-control px-2 mb-2 input-equal",
                                                isClearable: true,
                                                placeholderText: "เลือกเดือนเริ่มต้น",
                                                maxDate: endMonth
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "เดือนสิ้นสุด"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                selected: endMonth,
                                                onChange: function(date) {
                                                    return setEndMonth(date);
                                                },
                                                dateFormat: "yyyy-MM",
                                                showMonthYearPicker: true,
                                                className: "form-control px-2 mb-2 input-equal",
                                                isClearable: true,
                                                placeholderText: "เลือกเดือนสิ้นสุด",
                                                minDate: startMonth
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาร้านค้า",
                                                options: optionShop,
                                                value: optionShop.find(function(opt) {
                                                    return opt.value === shopId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setShopId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาสาขา"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาสาขา",
                                                options: optionBranch,
                                                value: optionBranch.find(function(opt) {
                                                    return opt.value === branchId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setBranchId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-6",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหาเซลล์ที่ดูแล"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                className: "w-100 select-st-3",
                                                placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                options: optionSale,
                                                value: optionSale.find(function(opt) {
                                                    return opt.value === saleId;
                                                }) || "",
                                                onChange: function(e) {
                                                    setSaleId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body pt-0 px-0",
                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: datalist,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalProduct,
                setModal: setModalProduct,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(SkuModal, {
                    setModal: setModalProduct,
                    modal: modalProduct,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            })
        ]
    });
}
export function SkuModal(param) {
    var modal = param.modal, setModal = param.setModal, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var getReportSaleSkuListsoldReducer = useAppSelector(function(state) {
        return state.getReportSaleSkuListsoldReducer;
    });
    var getReportSaleSkuListsnewReducer = useAppSelector(function(state) {
        return state.getReportSaleSkuListsnewReducer;
    });
    useEffect(function() {
        var _modal_data;
        var modalId = modal === null || modal === void 0 ? void 0 : (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.id;
        var typeData = modal === null || modal === void 0 ? void 0 : modal.typeData;
        if (!modalId || !typeData) return;
        var actionMap = {
            new: function() {
                return dispatch(getReportSaleSkuListsnew({
                    id: modalId
                }, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            },
            old: function() {
                return dispatch(getReportSaleSkuListsold({
                    id: modalId
                }, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        };
        var action = actionMap[typeData];
        if (action) {
            action();
        } else {
            console.warn("Unknown typeData: ".concat(typeData));
        }
    }, [
        modal === null || modal === void 0 ? void 0 : (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.id,
        modal === null || modal === void 0 ? void 0 : modal.typeData,
        dispatch,
        modalObj,
        setModalObj
    ]);
    useEffect(function() {
        var isFetching = getReportSaleSkuListsoldReducer.isFetching || getReportSaleSkuListsnewReducer.isFetching;
        setIsLoading(isFetching);
        if ((modal === null || modal === void 0 ? void 0 : modal.typeData) === "new" && getReportSaleSkuListsnewReducer.data) {
            setDatalist(getReportSaleSkuListsnewReducer.data.data || []);
        } else if ((modal === null || modal === void 0 ? void 0 : modal.typeData) === "old" && getReportSaleSkuListsoldReducer.data) {
            setDatalist(getReportSaleSkuListsoldReducer.data.data || []);
        }
    }, [
        getReportSaleSkuListsoldReducer,
        getReportSaleSkuListsnewReducer,
        modal === null || modal === void 0 ? void 0 : modal.typeData,
        setIsLoading
    ]);
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.pd_product_code;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/productlist/edit/" + row.pd_product_id + "/view",
                        children: row.pd_product_code ? row.pd_product_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "Barcode",
            width: "150px",
            selector: function(row) {
                return row.pd_product_barcode;
            },
            cell: function(row, index, column, id) {
                return row.pd_product_barcode ? row.pd_product_barcode : /*#__PURE__*/ _jsx("span", {
                    className: "ml-10",
                    children: "-"
                });
            }
        },
        {
            name: "ชื่อแบรนด์",
            width: "150px",
            selector: function(row) {
                return row.pd_product_brandid;
            },
            cell: function(row, index, column, id) {
                var _row_SetBrand, _row_SetBrand1;
                return row.SetBrand ? /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    justifyContent: "flex-start",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: (_row_SetBrand = row.SetBrand) === null || _row_SetBrand === void 0 ? void 0 : _row_SetBrand.set_brand_name
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: (_row_SetBrand1 = row.SetBrand) === null || _row_SetBrand1 === void 0 ? void 0 : _row_SetBrand1.set_brand_namela
                        })
                    ]
                }) : /*#__PURE__*/ _jsx("span", {
                    className: "ml-10",
                    children: "-"
                });
            }
        },
        {
            name: "ชื่อสินค้า",
            selector: function(row) {
                return row.pd_product_nameth;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: row.pd_product_image ? getFullUrlPath(row.pd_product_image) : "",
                            className: "imgprofile me-2"
                        }),
                        row.pd_product_nameth ? /*#__PURE__*/ _jsxs(Stack, {
                            direction: "column",
                            justifyContent: "flex-start",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: row.pd_product_nameth
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: row.pd_product_nameen
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx("span", {
                            className: "ml-10",
                            children: "-"
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "row gx-xl-4",
            children: /*#__PURE__*/ _jsx("div", {
                className: "col-xl-12 col-md-12",
                children: /*#__PURE__*/ _jsx(DataTableLayout, {
                    item: datalist,
                    columns: columns,
                    isSelectRows: false,
                    PerPage: 10
                })
            })
        })
    });
}
